import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import logo from '../../assets/logo.webp';

export const Footer = () => {
  const location = useLocation()
  const waitlist = location.pathname==="/participate-in-online-fitness-challenges" || location.pathname==="/waitlist"

  return(
  <div id="landing-footer" className="mt-5">
    <div className="footer flex-column px-md-5 flex-md-row flex-column-reverse">
      <div className="l-footer col-12 col-md-6 align-items-md-start">
        <img className="img-logo" src={logo} alt="Tigbar Logo" />
        <small className="copyright-text mt-md-2">
          &copy; www.tigbar.com. All rights reserved.
        </small>
      </div>
      <div className="r-footer col-12 col-md-6 justify-content-center justify-content-md-start flex-column align-items-md-end align-items-center">
        <div className="footer-links-container pb-1 pb-md-0">
          {/* <a className="footer-links ml-md-2" href="https://www.tigbar.com" target="_blank" rel="noreferrer">
            Sign Up
          </a> */}
          <NavLink 
          to={waitlist ? "/" : "/participate-in-online-fitness-challenges"} end className="footer-links ml-md-2">
            {waitlist ?'About':'Sign Up'}
          </NavLink>
          <a className="footer-links ml-md-2" href="https://blog.tigbar.com" target="_blank" rel="noreferrer">
            Blogs
          </a>
          <a className="footer-links ml-md-2" href="https://www.tigbar.com/privacy-policy" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          <a
            className="footer-links ml-md-2"
            href="https://www.tigbar.com/terms-conditions"
            target="_blank" rel="noreferrer"
          >
            Terms & Conditions
          </a>
        </div>
        <div className="icon-container py-2">
          <a className="icon" href="https://www.linkedin.com/company/tigbar" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a className="icon" href="https://www.instagram.com/tigbar.official" target="_blank" rel="noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a className="icon" href="https://www.facebook.com/thetigbar" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a className="icon" href="https://twitter.com/tigbar_official" target="_blank" rel="noreferrer">
            <i className="fab fa-twitter"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
)
};
